const STORAGE_KEY = "12go_promo_dismissed";

function readDismissed(): Record<string, 1> {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return {};
    const out: Record<string, 1> = {};
    for (const [id, value] of Object.entries(parsed as Record<string, unknown>)) {
      if (value) out[id] = 1;
    }
    return out;
  } catch {
    return {};
  }
}

export function isPromoDismissed(promoId: string): boolean {
  if (!promoId) return false;
  return Boolean(readDismissed()[promoId]);
}

export function dismissPromo(promoId: string): void {
  if (!promoId || typeof window === "undefined") return;
  try {
    const next = { ...readDismissed(), [promoId]: 1 as const };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* private mode / quota */
  }
}
